export enum HeaderDisplayState {
  NoDataSource,
  HasData,
  LoadingData,
  NoCGMData,
  NoCGMSession,
  NoPumpOrCGMData,
}
